import Home from './views/Home.vue'
import AboutUs from './views/AboutUs'
import ContactMe from './views/ContactMe.vue'
import ContactUs from './views/ContactUs.vue'
import Faqs from './views/Faqs.vue'
import ForAgents from './views/ForAgents.vue'
import NestEggDownloads from './views/NestEggDownloads.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import SellWithUs from './views/SellWithUs.vue'
import TermsOfUse from './views/TermsOfUse.vue'

const routes = [
    {
        path: '/about-us*',
        component: AboutUs,
        meta: {
            title: 'NestEgg - About Us',
            description: 'We make it simple! By selling with NestEgg, we take the uncertainty and risk out of selling your home.',
        }
    },
    {
        path: '/contact-me*',
        component: ContactMe,
        address: null,
        meta: {
            title: 'NestEgg - Contact Me',
            description: 'Looking to sell you home? Fill out our quick & easy contact form and we\'ll get in touch with you!',
        }
    },
    {
        path: '/contact-us*',
        component: ContactUs,
        meta: {
            title: 'NestEgg - Contact Us',
            description: 'Contact NestEgg - We\'d love to hear from you!'
        }
    },
    {
        path: '/faqs*',
        component: Faqs,
        meta: {
            title: 'NestEgg - FAQs',
            description: 'Is there anything you\'d like to know about NestEgg? Find answers to our most commonly asked questions here.',
        }
    },
    {
        path: '/for-agents*',
        component: ForAgents,
        meta: {
            title: 'NestEgg - For Agents',
            description: 'At NestEgg, we work together with local agents in your area to source the best buyers for your home.',
        }
    },
    {
        path: '/nestegg-downloads*',
        component: NestEggDownloads,
        meta: {
            title: 'NestEgg - Downloads',
            description: 'Want to check our credentials & view samples of our documents? Download copies here.',
        }
    },
    {
        path: '/privacy-policy*',
        component: PrivacyPolicy,
        meta: {
            title: 'NestEgg - Privacy Policy',
            description: 'At NestEgg we take your privacy & data security very seriously. Read our privacy policy here.',
        }
    },
    {
        path: '/sell-with-us*',
        component: SellWithUs,
        meta: {
            title: 'NestEgg - Sell With Us',
            description: 'Are you trying to sell your home the old way? At NestEgg, we\'ve recognised that you need a better way to sell, one that is simpler and more efficient',
        }
    },
    {
        path: '/terms-of-use*',
        component: TermsOfUse,
        meta: {
            title: 'NestEgg - Terms of Use',
            description: 'NestEgg\'s Terms of Use - These terms apply to anyone who uses our website or interacts with us.',
        }
    },
    {
        path: '/*',
        component: Home,
        meta: {
            title: 'NestEgg - Your Sellers\' Agent',
            description: 'Access the best buyers! We sell direct and partner with leading agents to make sure you get the highest price for your home. NestEgg - Your Sellers\' Agent',
        }
    }
];

export default routes;